var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share-buttons-list"},_vm._l((_vm.networks),function(network){return _c('SocialShareButton',{key:network,attrs:{"network":network,"data":_vm.shareData},on:{"open":function($event){return _vm.onOpen(network)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }